import { AssessmentWorkflowPage } from './AssessmentWorkflowPage'

export function ServiceLineAssessmentPage() {
  return <AssessmentWorkflowPage workflow="service_line" />
}
